export default "__VITE_PUBLIC_ASSET__cabbfa68__"